var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTransparency(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 56,
    viewBox: "0 0 45 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45 11.7229C44.8428 11.7637 44.6769 11.787 44.5081 11.787H34.1065C33.0006 11.787 32.1042 10.8906 32.1042 9.78463V0H0V55.2969H45V11.7229ZM22.5262 41.0332C15.4889 41.039 9.64494 35.5995 9.14726 28.5768C8.6234 21.1932 14.1851 14.7846 21.5687 14.2608V27.6222C21.5687 27.8754 21.6705 28.1199 21.851 28.3003L31.2951 37.7445C28.865 39.8632 25.7509 41.0332 22.5262 41.0332ZM32.6484 36.3911L24.837 28.5797H35.8848C35.681 31.4668 34.546 34.2084 32.6455 36.3911H32.6484ZM23.4837 26.6647V14.2608C30.1251 14.7439 35.4045 20.0233 35.8877 26.6647H23.4837Z",
    fill: "#08B1F4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransparency);
export default __webpack_public_path__ + "static/media/transparency.edd8fa8299b6fe6081d798106820da09.svg";
export { ForwardRef as ReactComponent };